var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{ closed: _vm.menu_opened }},[_c('SideNavigation',{on:{"menu-toggled":_vm.menu_toggled}}),_c('div',{staticClass:"wrapper"},[_c('TopNavigation'),_vm._v(" Security ins ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }